import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Communication: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.50977 18.9349C8.83126 19.6124 10.3645 20 11.9996 20C16.9702 20 21 16.4183 21 12C21 7.58173 16.9706 4 12 4C7.02944 4 3 7.58173 3 12C3 13.4535 3.43604 14.8164 4.19819 15.991L4.20114 15.9956C4.27448 16.1086 4.31146 16.1656 4.32821 16.2195C4.34401 16.2703 4.34842 16.3159 4.34437 16.3685C4.34003 16.425 4.3186 16.4836 4.27468 16.6007L3.50586 18.6509L3.50489 18.6536C3.34268 19.0862 3.26157 19.3025 3.31938 19.4466C3.36979 19.5722 3.48169 19.6714 3.62305 19.7162C3.78482 19.7675 4.02705 19.6957 4.51155 19.5522L4.51758 19.5502L6.82405 18.8668C6.95537 18.8279 7.02214 18.8082 7.08559 18.8043C7.14475 18.8007 7.19578 18.8054 7.25293 18.8195C7.31368 18.8344 7.37783 18.8673 7.50563 18.9328L7.50977 18.9349Z"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Communication;
